export default {"src":"/_next/static/image/src/assets/landing/logo.beb3ca8d9bf6acca168c4e5ecc28e688.svg","height":64,"width":64};